import { ModalTemplate } from "@deliverr/ui-facility";
import { FormattedMessage } from "react-intl";
import React from "react";
import { Button } from "@deliverr/ui";
import { PrintJobSummary } from "../useShipToStoreLabel";

interface PrintJobSummaryModalProps {
  shouldShowSummary: boolean;
  printSummary: PrintJobSummary;
  onContinue: () => void;
}

export const PrintJobSummaryModal: React.FC<PrintJobSummaryModalProps> = ({
  shouldShowSummary,
  printSummary,
  onContinue,
}) => {
  if (!shouldShowSummary) {
    return null;
  }

  return (
    <ModalTemplate
      title={
        <FormattedMessage id="sortation.shipToStoreLabel.printJobSummary.title" defaultMessage="Print Job Complete" />
      }
      text={
        <FormattedMessage
          id="sortation.shipToStoreLabel.printJobSummary.text"
          defaultMessage="Printed {successCount}/{totalLabels} labels."
          values={{
            successCount: printSummary.successCount,
            totalLabels: printSummary.totalLabels,
          }}
        />
      }
    >
      <Button block onClick={onContinue}>
        <FormattedMessage id="sortation.shipToStoreLabel.printJobSummary.continue" defaultMessage="Continue" />
      </Button>
    </ModalTemplate>
  );
};
